
import { useTranslation } from "react-i18next";
import { Search, FileText, Network, Users, Layout } from "lucide-react";
import { Link } from "react-router-dom";

const Features = () => {
  const { t } = useTranslation(["features"]);

  const features = [
    {
      icon: <Users className="w-8 h-8 text-brand-orange" />,
      title: t('diversity.title'),
      description: t('diversity.description')
    },
    {
      icon: <Layout className="w-8 h-8 text-brand-orange" />,
      title: t('platform.title'),
      description: t('platform.description')
    },
    {
      icon: <Search className="w-8 h-8 text-brand-orange" />,
      title: t('searchEngine.title'),
      description: t('searchEngine.description'),
      link: "/search-engine",
      linkText: t('searchEngine.cta')
    },
    {
      icon: <Network className="w-8 h-8 text-brand-orange" />,
      title: t('metaReferential.title'),
      description: t('metaReferential.description'),
      link: "/meta-referentiel",
      linkText: t('metaReferential.cta')
    },
    {
      icon: <FileText className="w-8 h-8 text-brand-orange" />,
      title: t('rncp.title'),
      description: t('rncp.description'),
      link: "/rncp-presentation",
      linkText: t('rncp.cta')
    }
  ];

  return (
    <section className="py-24 bg-background relative">
      <div className="container-custom">
        <h2 className="text-4xl sm:text-5xl font-bold text-center mb-16 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange">
          {t('title')}
        </h2>
        
        {/* Version mobile */}
        <div className="md:hidden space-y-12">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center gap-8 group"
            >
              <div className="relative">
                <div className="w-20 h-20 bg-gradient-to-br from-background to-muted rounded-2xl flex items-center justify-center shadow-lg border border-border group-hover:scale-110 transition-transform duration-300">
                  {feature.icon}
                </div>
                <div className="absolute inset-0 bg-brand-orange/10 blur-2xl -z-10" />
              </div>
              
              <div className="flex-1 text-center">
                <h3 className="text-2xl font-medium text-foreground mb-4 group-hover:text-brand-orange transition-colors">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground mb-4">
                  {feature.description}
                </p>
                {feature.link && (
                  <Link 
                    to={feature.link}
                    className="inline-flex items-center text-brand-orange hover:text-brand-blue transition-colors gap-2"
                  >
                    <span className="relative">
                      {feature.linkText}
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current group-hover:w-full transition-all duration-300" />
                    </span>
                    <svg 
                      className="w-4 h-4 group-hover:translate-x-1 transition-transform" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7" 
                      />
                    </svg>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Version desktop */}
        <div className="hidden md:grid md:grid-cols-3 gap-x-8 gap-y-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group"
            >
              <div className="relative h-52 mb-6 rounded-2xl bg-gradient-to-br from-background to-muted border border-border flex items-center justify-center overflow-hidden shadow-lg">
                <div className="absolute inset-0 bg-gradient-to-tr from-brand-orange/5 via-transparent to-brand-blue/5 group-hover:scale-150 transition-transform duration-700" />
                <div className="relative transform group-hover:-translate-y-2 transition-transform duration-300">
                  {feature.icon}
                </div>
              </div>
              
              <div>
                <h3 className="text-xl font-medium text-foreground mb-3 group-hover:text-brand-orange transition-colors">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground mb-4">
                  {feature.description}
                </p>
                {feature.link && (
                  <Link 
                    to={feature.link}
                    className="inline-flex items-center text-brand-orange hover:text-brand-blue transition-colors gap-2"
                  >
                    <span className="relative">
                      {feature.linkText}
                      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-current group-hover:w-full transition-all duration-300" />
                    </span>
                    <svg 
                      className="w-4 h-4 group-hover:translate-x-1 transition-transform" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7" 
                      />
                    </svg>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
